const RELOAD_KEY = 'bluebear:route-load-reload';
const COOLDOWN_MS = 5 * 60 * 1000;

export function isRouteLoadError(error) {
  const message = typeof error === 'string' ? error : error?.message;
  return typeof message === 'string' && /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading (?:CSS )?chunk .+ failed|ChunkLoadError/i.test(message);
}

// Session storage survives a reload. If unavailable, fail visibly instead of risking a loop.
export function recoverRouteLoad(error, browser = window, now = Date.now()) {
  if (!isRouteLoadError(error)) return false;
  try {
    const previous = Number(browser.sessionStorage.getItem(RELOAD_KEY));
    if (previous && now - previous < COOLDOWN_MS) return false;
    browser.sessionStorage.setItem(RELOAD_KEY, String(now));
    browser.location.reload();
    return true;
  } catch {
    return false;
  }
}

export function installRouteLoadRecovery(browser = window) {
  const onPreloadError = event => {
    if (recoverRouteLoad(event.payload, browser)) event.preventDefault();
  };
  browser.addEventListener('vite:preloadError', onPreloadError);
  return () => browser.removeEventListener('vite:preloadError', onPreloadError);
}
